import { _ } from "js/vendor";
import { sharedThemes as sharedThemesApi } from "apis/callables";
import type { ITheme } from "common/interfaces";
import db from "js/db";

import ApiAdapter from "./apiAdapter";

class sharedThemesAdapter extends ApiAdapter<ITheme, {}> {
    async _createApi(model: ITheme) {
        return await sharedThemesApi.createSharedTheme(model);
    }

    async _updateApi(
        changesetUpdates: Partial<ITheme>, changesetOriginal: Partial<ITheme>
    ): Promise<Partial<ITheme>> {
        const { modifiedAt, _changeId } = await sharedThemesApi.updateSharedTheme({
            id: this.id,
            changesetOriginal,
            changesetUpdates,
            _changeId: this.model.attributes._changeId,
        });
        return { modifiedAt, _changeId };
    }

    async _getApi() {
        return await sharedThemesApi.getSharedTheme({
            id: this.id,
        });
    }

    _composeModel(baseModel: Partial<ITheme>): ITheme {
        return { ...baseModel, id: this.id } as ITheme;
    }

    _getPusherChannelId(): string | null {
        return `private-shared-theme-${this.id}`;
    }

    createUid() {
        return db().push().key as string;
    }
}

export default sharedThemesAdapter;
